import { Button, Card, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '../ui/components';
import { officeCompanies, useWorkplace } from './access';
import { useDb } from './supabase';

/** D12 Profile: who is signed in, role, language (English only for now), sign out. */
export function ProfilePage() {
  const { t } = useTranslation(['dashboard', 'common']);
  const db = useDb();
  const { access } = useWorkplace();
  return (
    <>
      <PageTitle title={t('profile.title')} />
      <Card withBorder maw={560}>
        <Stack>
          <Text fw={700}>{access.fullName}</Text>
          <Text>{access.email}</Text>
          <Text>
            {access.isAdmin
              ? t('profile.admin')
              : t('profile.dpa', {
                  companies: officeCompanies(access)
                    .map((c) => c.name)
                    .join(', '),
                })}
          </Text>
          <Text>{t('profile.language', { language: t('common:languages.en') })}</Text>
          <Button variant="default" onClick={() => void db.auth.signOut()} w="fit-content">
            {t('profile.signOut')}
          </Button>
        </Stack>
      </Card>
    </>
  );
}
